// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"446": "recorder","890": "profiler",}[chunkId] + "-internal-9f13b6b7-d52f-482f-b4ea-b1146b6adb48-" + {"446": "a61591452c6c6771","890": "eaacd65584aeaec3",}[chunkId] + ".js"
}